// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const great_tusk: PokeData = {
  "id": 984,
  "name": "great-tusk",
  "height": 22,
  "weight": 3200,
  "base_experience": 285,
  "types": [
    PokeType.GROUND,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "horn-attack",
    "earthquake",
    "defense-curl",
    "rollout",
    "megahorn",
    "rapid-spin",
    "sunny-day",
    "taunt",
    "brick-break",
    "knock-off",
    "endeavor",
    "close-combat",
    "giga-impact",
    "head-smash",
    "bulldoze",
    "stomping-tantrum",
    "headlong-rush"
  ],
  "moves": [
    "earthquake",
    "sunny-day",
    "close-combat",
    "vacuum-wave",
    "mud-slap",
    "bulk-up",
    "bonemerang",
    "superpower",
    "earth-power",
    "jump-kick",
    "rolling-kick",
    "mud-bomb",
    "karate-chop"
  ],
  "evolution_chain": {
    "id": 515,
    "item": null,
    "species": [
      {
        "name": "great-tusk",
        "order": 978,
        "types": [
          PokeType.GROUND,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 129,
    "speed": 108,
    "ability_power": 163
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
